import { Component, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from '../loader.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    encapsulation: ViewEncapsulation.ShadowDom,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SpinnerComponent {
  loading$: Observable<boolean>;
  
  constructor(public loader: LoaderService) { 
    this.loading$ = this.loader.loading$;
  }
}
